import React from 'react'
import clsx from 'clsx'
import { Portal } from '@mui/material'

import UploadIcon from '../UploadIcon'

import useStyles from './styles'

const UploadBox: React.FC = () => {
  const classes = useStyles()

  return (
    <Portal>
      <div className={classes.root}>
        <div className={classes.content}>
          <UploadIcon className={classes.icon} />

          <div className={clsx(classes.text, classes.title)}>
            Upload to SonarCX
          </div>

          <div className={clsx(classes.text, classes.subtitle)}>
            Drag & Drop files to share
          </div>
        </div>
      </div>
    </Portal>
  )
}

export default UploadBox
